export default __webpack_public_path__ + "static/media/pizza-2.e103d354.jpg";